
import Vue from 'vue'
import Router from 'vue-router'
import homepge from '@/components/homepage.vue'
import myfans from '@/components/myfans.vue'
import myfollow from '@/components/myfollow.vue'
import bookcommentList from '@/components/bookcommentList.vue'
import bookList from '@/components/bookList.vue'
import editInput from '@/components/editInput.vue'

Vue.use(Router)
const edit = resolve => {
  require.ensure(['@/components/edit.vue'], () => {
    resolve(require('@/components/edit.vue'))
  })
}
const commentDetail = resolve => {
  require.ensure(['@/components/commentDetail.vue'], () => {
    resolve(require('@/components/commentDetail.vue'))
  })
}
export default new Router({
    routes: [{
            path: '/',
            name: 'homepge',
            component: homepge
        },
        {
            path: '/myfans',
            name: 'myfans',
            component: myfans
        },
        {
            path: '/myfollow',
            name: 'myfollow',
            component: myfollow
        },
        {
            path: '/bookcommentList/:comment_type',
            name: 'bookcommentList',
            component: bookcommentList
        },
        {
            path: '/commentDetail/:commentPara',
            name: 'commentDetail',
            component: commentDetail
        },
        {
            path: '/bookList',
            name: 'bookList',
            component: bookList
        },
        {
            path: '/edit',
            name: 'edit',
            component: edit
        },
        {
            path: '/editInput/:item',
            name: 'editInput',
            component: editInput
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js